import React from "react";

import Introduction from "../components/introduction";
import News from "../components/news/news";
import CV from "../components/cv";

import posts from "../content/blog/posts.generated.json";
import cvEvents from "../content/cv";

const highlights = posts.filter((p) => p.highlight);
const cvHighlights = cvEvents.filter((e) => e.highlight);

// Landing page: intro, the highlight stories, and the CV timeline.
const Home = () => {
    return (
        <>
            <Introduction></Introduction>
            <h1 id="Highlights">Highlights</h1>
            <News posts={highlights}></News>
            <h1 id="CV">Curriculum Vitae</h1>
            <CV events={cvHighlights} dense></CV>
        </>
    );
};

export default Home;
